import { createAction, makeActionTrackable } from '@lingoda/core';

export interface Payload {
    notification: string;
    value: unknown;
}

export default makeActionTrackable(createAction<Payload>('student/SET_NOTIFICATION_VALUE'));
